// extracted by mini-css-extract-plugin
export var address = "Footer-module--address--55y05";
export var footer = "Footer-module--footer--LZE0a";
export var footerBottom = "Footer-module--footerBottom--5Ip47";
export var footerCopyright = "Footer-module--footerCopyright--Kpvy2";
export var footerMin = "Footer-module--footerMin--JG2eE";
export var footerMinContent = "Footer-module--footerMinContent--hH6mP";
export var footerMinContentHeader = "Footer-module--footerMinContentHeader--VMQQs";
export var footerTop = "Footer-module--footerTop--WutqP";
export var footer_listItem = "Footer-module--footer_listItem--nq+1i";
export var footer_listItemMin = "Footer-module--footer_listItemMin--V1neT";
export var icon = "Footer-module--icon--H1hpl";
export var iconArrow = "Footer-module--iconArrow--tBd7J";
export var img = "Footer-module--img--8NHXD";
export var pseudoIcon = "Footer-module--pseudoIcon--h7RwY";